"use client";

import { useState } from "react";
import { useFormStatus } from "react-dom";
import Form from "next/form";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { deleteUsersAction } from "../actions";
import DialogAlert from "./DialogAlert";
import { UserList } from "./UserList";
import { User } from "@/api/users";

function SubmitButton() {
  const { pending } = useFormStatus();

  return (
    <Button type="submit" color="error" variant="contained" disabled={pending}>
      {pending ? "Deleting..." : "Delete"}
    </Button>
  );
}

export default function DeleteUsersButton({ users }: { users: User[] }) {
  const [open, setOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setAlertVisible(false);
    setOpen(false);
  };

  const handleAction = async (formData: FormData) => {
    const result = await deleteUsersAction(formData);
    if (result.success) {
      handleClose();
    } else {
      setAlertVisible(true);
    }
  };

  return (
    <>
      <Button variant="outlined" color="error" onClick={handleOpen}>
        Delete Users
      </Button>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <Form action={handleAction}>
          <DialogAlert
            message="There was a problem deleting users"
            setVisible={setAlertVisible}
            visible={alertVisible}
          />
          <DialogTitle>Delete Users</DialogTitle>
          <DialogContent>
            <p className="mb-5">
              Are you sure you want to delete the selected users? This action is{" "}
              <strong>irreversible</strong>.
            </p>
            <UserList users={users} />
            {users.map((user) => (
              <input key={user.id} type="hidden" name="ids" value={user.id} />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" type="button">
              Cancel
            </Button>
            <SubmitButton />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
